import React from 'react';
import {Table, Glyphicon} from 'react-bootstrap';

import Auxiliary from '../../hoc/Auxiliary/Auxiliary';

import './Table.css';

const table = (props) => {

    let arrow = <Glyphicon glyph="arrow-down" style={{color:'red', padding:'0 0 0 5px'}} />;
    if (props.up)
        arrow = <Glyphicon glyph="arrow-up" style={{color:'lawngreen', padding:'0 0 0 5px'}} />;
    
    return (
        <Auxiliary>
            <div className="TableHeader"><span>{props.title}</span></div>
            <div className="TableBody">
                <Table striped bordered condensed hover>
                    <thead>
                        <tr>
                            <th>Location</th>
                            <th>Index</th>
                            <th>Change</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>{props.first.location}</td>
                            <td>{isNaN(props.first.nps) ? '' : props.first.nps.toFixed(0)}</td>
                            {isNaN(props.first.diff) ? <td>&nbsp;</td> : <td>{props.first.diff.toFixed(1)}%{arrow}</td>}
                        </tr>
                        <tr>
                            <td>{props.second.location}</td>
                            <td>{isNaN(props.second.nps) ? '' : props.second.nps.toFixed(0)}</td>
                            {isNaN(props.second.diff) ? <td>&nbsp;</td> : <td>{props.second.diff.toFixed(1)}%{arrow}</td>}
                        </tr>
                    </tbody>
                </Table>
            </div>
        </Auxiliary>
    );
};

export default table;